import {
  LoadingStrategyOption,
  RecommendationType,
} from '@/webapi/use-widget-catalog-api';

export const ALL_RECOMMENDATION_STRATEGIES: Record<
  RecommendationType,
  Pick<LoadingStrategyOption, `label` | `description`>
> = {
  [RecommendationType.MANUAL]: {
    label: `I want to choose manually`,
    description: `Choose the specific items you'd like to display`,
  },
  [RecommendationType.CART_ITEMS]: {
    label: `Cart Items`,
    description: `Present items from the user's shopping cart`,
  },
  [RecommendationType.PERSONALIZED]: {
    label: `personalized`,
    description: `Display items based on your customers behaviour`,
  },
  [RecommendationType.MOST_POPULAR]: {
    label: `Most Popular`,
    description: `Display items that were sold the most in the past 30 days`,
  },
  [RecommendationType.NEW_ARRIVALS]: {
    label: `New Arrivals`,
    description: `Display items that just arrived`,
  },
  [RecommendationType.VIEWD_TOGETHER]: {
    label: `Viewed Together`,
    description: `Display items that your customers viewed together`,
  },
  [RecommendationType.RECENTLY_VIEWED]: {
    label: `Recently Viewed`,
    description: `Show items that the users viewed on recent visits`,
  },
  [RecommendationType.PURCHASED_TOGETHER]: {
    label: `Purchased Together`,
    description: `Display items frequently purchased together`,
  },
  [RecommendationType.ADVANCED_RULING]: {
    label: `Advanced Ruling`,
    description: `Display items based on custom logic`,
  },
  [RecommendationType.PAST_PURCHASES]: {
    label: `Purchased Items`,
    description: `Show purchased products`,
  },
  [RecommendationType.MOST_CHEAP_IN_CART]: {
    label: `Most Cheap In Cart`,
    description: `Display the cheapest items from the user's cart`,
  },
  [RecommendationType.MOST_EXPENSIVE_IN_CART]: {
    label: `Most Expensive In Cart`,
    description: `Display the most expensive items from the user's cart`,
  },
  [RecommendationType.VIEWED_WITH_RECENTLY_VIEWED]: {
    label: `Viewed With Recently Viewed`,
    description: `Items typically viewed in the same session as the user's last viewed items`,
  },
  [RecommendationType.PURCHASED_WITH_RECENTLY_PURCHASED]: {
    label: `Purchased With Recently Purchased`,
    description: `Items often purchased with the user's last purchased items`,
  },
};

export function getStrategiesByType(
  types: RecommendationType[],
): LoadingStrategyOption[] {
  return types.map((type) => ({
    ...ALL_RECOMMENDATION_STRATEGIES[type],
    value: { fn: ``, template: ``, type },
  }));
}
